<template>
    <div>
        <v-row justify="center">
            <v-col cols="6">
                <v-card>
                    <v-toolbar flat>
                        <v-toolbar-title>Perfil</v-toolbar-title>
                    </v-toolbar>
                    <v-tabs vertical>
                        <v-tab class="justify-start">
                            <v-icon style="text-align: left;" left>mdi-account</v-icon>
                            Trocar Senha
                        </v-tab>
                        <v-tab class="justify-start">
                            <v-icon style="text-align: left;" left>mdi-lock</v-icon>
                            Informações Pessoais
                        </v-tab>

                        <v-tab-item>
                            <v-form ref="trocarSenhaForm">
                                <v-container>
                                    <v-text-field
                                            ref="new-password"
                                            v-model="senhaAtual"
                                            :rules="[() => !!senhaAtual || 'Digite a senha atual!']"
                                            :append-icon=" showAppendSenhaAtual ? 'mdi-eye' : 'mdi-eye-off'"
                                            name="input-10-1"
                                            :type=" showAppendSenhaAtual ? 'text' : 'password'"
                                            label="Senha atual"
                                            counter
                                            autocomplete="password"
                                            outlined
                                            @click:append="showAppendSenhaAtual = !showAppendSenhaAtual"
                                    ></v-text-field>

                                    <v-text-field
                                            ref="new-password"
                                            v-model="senha"
                                            :rules="[rules.required, rules.min, rules.igualAtual]"
                                            :append-icon=" showAppendSenha ? 'mdi-eye' : 'mdi-eye-off'"
                                            name="input-10-1"
                                            :type=" showAppendSenha ? 'text' : 'password'"
                                            label="Nova senha"
                                            counter
                                            outlined
                                            autocomplete="password"
                                            @click:append="showAppendSenha = !showAppendSenha"
                                    ></v-text-field>

                                    <v-text-field
                                            v-model="senhaRepetida"
                                            :append-icon=" showAppendSenhaRepetida ? 'mdi-eye' : 'mdi-eye-off'"
                                            :rules="[() => !!senhaAtual || 'Digite a nova senha novamente!', rules.igual]"
                                            name="input-10-1"
                                            :type=" showAppendSenhaRepetida ? 'text' : 'password'"
                                            label="Repita a senha"
                                            counter
                                            outlined
                                            autocomplete="password"
                                            @click:append="showAppendSenhaRepetida = !showAppendSenhaRepetida"
                                    ></v-text-field>
                                </v-container>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green" :loading="salvandoSenha"
                                       @click="salvarSenha" :dark="true">Salvar
                                </v-btn>
                            </v-card-actions>
                        </v-tab-item>
                        <v-tab-item>
                            <v-form ref="infoPessoalForm">
                                <v-container>
                                    <v-text-field v-model="usuario.login" label="Login" outlined
                                                  disabled></v-text-field>

                                    <v-text-field
                                            v-model="usuario.nome"
                                            label="Nome"
                                            outlined
                                            :rules="[() => !!usuario.nome || 'Campo obrigatório!']"
                                    ></v-text-field>

                                    <v-text-field v-model="usuario.email" label="Email" outlined
                                                  :rules="[rules.email]"></v-text-field>
                                </v-container>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn style="text-align: right"
                                       color="green"
                                       @click="salvarInformacaoPessoal"
                                       :loading="salvandoInfoPessoal"
                                       :dark="true"
                                >Salvar
                                </v-btn>
                            </v-card-actions>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-col>
        </v-row>
        <!-- SNACKBAR DIALOG -->
        <v-snackbar
                v-model="snackbar.active"
                style="margin-top: 60px;"
                :color="snackbar.color"
                :top="true"
                :right="true"
        >{{snackbar.message}}
        </v-snackbar>
    </div>
</template>

<script>

    import UsuarioService from "../../service/UserService";
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                showAppendSenha: false,
                showAppendSenhaAtual: false,
                showAppendSenhaRepetida: false,
                senha: "",
                senhaAtual: "",
                senhaRepetida: "",
                showPassword: false,
                trocarSenhaCard: null,
                infoPessoalCard: null,
                salvandoSenha: false,
                salvandoInfoPessoal: false,
                snackbar: {
                    message: "",
                    color: "error",
                    active: false
                },
                usuario: {
                    login: null,
                    nome: null,
                    email: ""
                },

                // eslint-disable-next-line no-useless-escape
                email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || "Requerido",
                    min: v => (v ? v.length : "" >= 8 || "Min 8 characters"),
                    igual: () =>
                        this.senha == this.senhaRepetida || "Senhas não são iguais",
                    igualAtual: () =>
                        this.senhaAtual != this.senha || "Senha atual é igual a nova senha",
                    email: () => this.email.test(this.usuario.email) || "E-mail invalido"
                }
            }
        },
        computed: {
            ...mapGetters({
                user: 'Login/user'
            })
        },
        methods: {
            salvarSenha() {
                if (this.$refs.trocarSenhaForm.validate()) {
                    this.salvandoSenha = true;
                    let body = {
                        senhaAtual: new Buffer(this.senhaAtual).toString("base64"),
                        novaSenha: new Buffer(this.senha).toString("base64"),
                        senhaRepetida: new Buffer(this.senhaRepetida).toString("base64")
                    };

                    UsuarioService.trocarSenha(body)
                        .then(() => {
                            this.showMessage(`Senha atualizada com sucesso!`, "success");
                            this.$refs.trocarSenhaForm.reset();
                        })
                        .catch(error => {
                            if (error == 406) {
                                this.showMessage("Senha atual incorreta!", "error");
                            }
                        })
                        .finally(() => {
                            this.salvandoSenha = false;
                        });
                }
            },
            salvarInformacaoPessoal() {
                if (this.$refs.infoPessoalForm.validate()) {
                    let body = {
                        email: this.usuario.email,
                        nome: this.usuario.nome
                    };
                    this.salvandoInfoPessoal = true;
                    UsuarioService.updateUsuario(body)
                        .then(() => {
                            this.user.nome = this.usuario.nome;
                            this.showMessage(
                                "Informações pessoais salvas com sucesso!",
                                "success"
                            );
                        })
                        .finally(() => {
                            this.salvandoInfoPessoal = false;
                        });
                }
            },
            showMessage(message, color) {
                this.snackbar.message = message;
                this.snackbar.color = color;
                this.snackbar.active = true;
            }
        },
        created() {
            UsuarioService.buscarDados().then(response => {
                this.usuario = response.data;
            });
        }
    }
</script>
